import { SlugBlacklistRepository } from '@lib/api/repository/slug-blacklist';
import {
  SlugPatternInput,
  UpdateSlugPatternInput,
} from '@lib/types/slug-blacklist';

export default class SlugBlacklistService {
  constructor(private repository: SlugBlacklistRepository) {}
  list(signal?: AbortSignal) {
    return this.repository.list(signal);
  }

  create(input: SlugPatternInput) {
    return this.repository.create(input);
  }

  update(input: UpdateSlugPatternInput) {
    return this.repository.update(input);
  }

  delete(id: string) {
    return this.repository.delete(id);
  }
}
